<script setup lang="ts">
  import Header  from '@/components/Header/Head.vue';
  import Footer from '@/components/Footer/Foot.vue';
</script>

<template>
  <Header />
  <main>
    <slot></slot>
  </main>
  <Footer />
</template>

